module.exports = __webpack_public_path__ + "media/Skin_extract.932e662e.mp3";